import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import GithubSlugger from 'github-slugger'

export const Context = createContext()

export const Provider = ({ children, step = 0 }) => {
	const slugger = new GithubSlugger()
	const initialState = { step, slug: x => slugger.slug(x) }
	return <Context.Provider value={initialState}>{children}</Context.Provider>
}

export const useStepContext = ({ skip }) => {
	const context = useContext(Context)
	if (skip) return context
	context.step += 1
	return context
}

Provider.propTypes = { step: PropTypes.number }
